import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  FormFeedback
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import "react-rangeslider/lib/index.css"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  updateAbout as onUpdateAbout,
  getAbout as onGetAbout,
} from "store/contacts/actions";

import CustomEditor from '../../../components/CustomEditor';
import { Base64 } from 'js-base64';
import axios from "axios";

const EcommerceAddProduct = () => {
  document.title = "Hakkımızda Bilgileri | CASTOR Admin Paneli";

  const dispatch = useDispatch();

  const [getContactEdit, setContactEdit] = useState(null);
  const [getHtmlDataLong, setHtmlDataLong] = useState(null);
  const [getHtmlDataLongEng, setHtmlDataLongEng] = useState(null);
  const [getHtmlDataLongThird, setHtmlDataLongThird] = useState(null);
  const [getFileName, setFileName] = useState('');


const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      mission: (getContactEdit && getContactEdit.Mission) || '',
      vission: (getContactEdit && getContactEdit.Vision) || '',
      shortdesc: (getContactEdit && getContactEdit.ShortDesc) || '',


      missioneng: (getContactEdit && getContactEdit.MissionEng) || '',
      vissioneng: (getContactEdit && getContactEdit.VisionEng) || '',
      shortdesceng: (getContactEdit && getContactEdit.ShortDescEng) || '',



      missionthird: (getContactEdit && getContactEdit.MissionThird) || '',
      vissionthird: (getContactEdit && getContactEdit.VisionThird) || '',
      shortdescthird: (getContactEdit && getContactEdit.ShotDescThird) || '',
    },
    validationSchema: Yup.object({
      shortdesc: Yup.string().required("Lütfen Kısa Açıklama Giriniz")
    }),
    onSubmit: (values) => {

      const updateOrder = {
        ID: users ? users[0].ID : 0,

        About_Desc: Base64.encode(getHtmlDataLong),
        AboutDescEng: Base64.encode(getHtmlDataLongEng),
        AboutDescThird: Base64.encode(getHtmlDataLongThird),

        Mission: values.mission,
        Vision: values.vission,
        ShortDesc: values.shortdesc,


        MissionEng: values.missioneng,
        VisionEng: values.vissioneng,
        ShortDescEng: values.shortdesceng,


        MissionThird: values.missionthird,
        VisionThird: values.vissionthird,
        ShotDescThird: values.shortdescthird,

      };
      // update order
      dispatch(onUpdateAbout(updateOrder));
      validation.resetForm();

    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.about,
  }));

  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetAbout());

    }
  }, [dispatch, users]);

  useEffect(() => {
    console.log("nsdlf", users)
    if (users.length > 0) {
      setContactEdit(users[0]);
    }
  }, [users]);

// useEffect bloğunu bununla değiştir:
  useEffect(() => {
    if (!isEmpty(users)) {
      const user = users[0];
      setContactEdit(user);
      
      // Editörlerin içini dolduracak kodlar:
      if (user.AboutDesc || user.About_Desc) {
         setHtmlDataLong(Base64.decode(user.AboutDesc || user.About_Desc));
      }
      if (user.AboutDescEng) {
         setHtmlDataLongEng(Base64.decode(user.AboutDescEng));
      }
      if (user.AboutDescThird) {
         setHtmlDataLongThird(Base64.decode(user.AboutDescThird));
      }
    }
  }, [users]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Hakkımızda Bilgileri" />

          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <CardTitle>Hakkımızda Bilgileri</CardTitle>

                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <Row>

                      <div className="mb-3">
                        <Label htmlFor="productname">Neden Biz kısa açıklama</Label>
                        <Input
                          id="shortdesc"
                          name="shortdesc"
                          type="text"
                          className="form-control"
                          placeholder="Başlık"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.shortdesc || ""}
                          invalid={
                            validation.touched.shortdesc && validation.errors.shortdesc ? true : false
                          }
                        />
                        {validation.touched.shortdesc && validation.errors.shortdesc ? (
                          <FormFeedback type="invalid">{validation.errors.shortdesc}</FormFeedback>
                        ) : null}

                      </div>
                      <div className="mb-3">
                        <Label htmlFor="productname">Neden Biz kısa açıklama Eng</Label>
                        <Input
                          id="shortdesceng"
                          name="shortdesceng"
                          type="text"
                          className="form-control"
                          placeholder="Başlık"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.shortdesceng || ""}
                          invalid={
                            validation.touched.shortdesceng && validation.errors.shortdesceng ? true : false
                          }
                        />
                        {validation.touched.shortdesceng && validation.errors.shortdesceng ? (
                          <FormFeedback type="invalid">{validation.errors.shortdesceng}</FormFeedback>
                        ) : null}

                      </div>
                      <div className="mb-3">
                        <Label htmlFor="productname">Neden Biz kısa açıklama Third</Label>
                        <Input
                          id="shortdescthird"
                          name="shortdescthird"
                          type="text"
                          className="form-control"
                          placeholder="Başlık"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.shortdescthird || ""}
                          invalid={
                            validation.touched.shortdescthird && validation.errors.shortdescthird ? true : false
                          }
                        />
                        {validation.touched.shortdescthird && validation.errors.shortdescthird ? (
                          <FormFeedback type="invalid">{validation.errors.shortdescthird}</FormFeedback>
                        ) : null}

                      </div>







                      <div className="mb-3">
                        <Label htmlFor="productname">Misyon</Label>
                        <Input
                          id="mission"
                          name="mission"
                          type="text"
                          className="form-control"
                          placeholder="Misyon"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.mission || ""}
                          invalid={
                            validation.touched.mission && validation.errors.mission ? true : false
                          }
                        />
                        {validation.touched.mission && validation.errors.mission ? (
                          <FormFeedback type="invalid">{validation.errors.mission}</FormFeedback>
                        ) : null}

                      </div>
                      <div className="mb-3">
                        <Label htmlFor="productname">Misyon Eng</Label>
                        <Input
                          id="missioneng"
                          name="missioneng"
                          type="text"
                          className="form-control"
                          placeholder="Misyon"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.missioneng || ""}
                          invalid={
                            validation.touched.missioneng && validation.errors.missioneng ? true : false
                          }
                        />
                        {validation.touched.missioneng && validation.errors.missioneng ? (
                          <FormFeedback type="invalid">{validation.errors.missioneng}</FormFeedback>
                        ) : null}

                      </div>
                      <div className="mb-3">
                        <Label htmlFor="productname">Misyon Third</Label>
                        <Input
                          id="missionthird"
                          name="missionthird"
                          type="text"
                          className="form-control"
                          placeholder="Misyon"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.missionthird || ""}
                          invalid={
                            validation.touched.missionthird && validation.errors.missionthird ? true : false
                          }
                        />
                        {validation.touched.missionthird && validation.errors.missionthird ? (
                          <FormFeedback type="invalid">{validation.errors.missionthird}</FormFeedback>
                        ) : null}

                      </div>





                       <div className="mb-3">
                        <Label htmlFor="productname">Vizyon</Label>
                        <Input
                          id="vission"
                          name="vission"
                          type="text"
                          className="form-control"
                          placeholder="Vizyon"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.vission || ""}
                          invalid={
                            validation.touched.vission && validation.errors.vission ? true : false
                          }
                        />
                        {validation.touched.vission && validation.errors.vission ? (
                          <FormFeedback type="invalid">{validation.errors.vission}</FormFeedback>
                        ) : null}

                      </div>
                      <div className="mb-3">
                        <Label htmlFor="productname">Vizyon Eng</Label>
                        <Input
                          id="vissioneng"
                          name="vissioneng"
                          type="text"
                          className="form-control"
                          placeholder="Vizyon"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.vissioneng || ""}
                          invalid={
                            validation.touched.vissioneng && validation.errors.vissioneng ? true : false
                          }
                        />
                        {validation.touched.vissioneng && validation.errors.vissioneng ? (
                          <FormFeedback type="invalid">{validation.errors.vissioneng}</FormFeedback>
                        ) : null}

                      </div>

                      <div className="mb-3">
                        <Label htmlFor="productname">Vizyon Third</Label>
                        <Input
                          id="vissionthird"
                          name="vissionthird"
                          type="text"
                          className="form-control"
                          placeholder="Vizyon"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.vissionthird || ""}
                          invalid={
                            validation.touched.vissionthird && validation.errors.vissionthird ? true : false
                          }
                        />
                        {validation.touched.vissionthird && validation.errors.vissionthird ? (
                          <FormFeedback type="invalid">{validation.errors.vissionthird}</FormFeedback>
                        ) : null}

                      </div>






              <div className="mb-3">
  <Label className="form-label">Uzun Açıklama</Label>
  <CustomEditor
    data={getHtmlDataLong}
    onChange={(newData) => setHtmlDataLong(newData)}
  />
</div>

<div className="mb-3">
  <Label className="form-label">Uzun Açıklama Eng</Label>
  <CustomEditor
    data={getHtmlDataLongEng}
    onChange={(newData) => setHtmlDataLongEng(newData)}
  />
</div>

<div className="mb-3">
  <Label className="form-label">Uzun Açıklama Third</Label>
  <CustomEditor
    data={getHtmlDataLongThird}
    onChange={(newData) => setHtmlDataLongThird(newData)}
  />
</div>

                    </Row>
                    <div className="d-flex flex-wrap gap-2">
                      <Button type="submit" color="primary" className="btn ">
                        Kaydet
                      </Button>
                      <Button type="submit" color="secondary" className=" ">
                        İptal
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>


            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default EcommerceAddProduct
